import { useTransl } from 'shared/lib/i18n';

const NoTableDataComponent = () => {
  const { t } = useTransl();
  return <div className="rt-noData">{t('table.noRowsFound')}</div>;
};

export default NoTableDataComponent;
